import React from 'react';
import { graphql, Link, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Disclosure } from '@headlessui/react';
import { ChevronUpIcon } from '@heroicons/react/24/solid';

import { Section, Container, SectionHeader } from '../../common';

const MapFull = (props) => {
  const { sanity, page } = props;
  const { gbp } = page;
  const { colors, map } = sanity;

  return (
    <Section idName="map-full" bgColor={colors?.neutral?.light}>
      <Container>
        <SectionHeader
          sanity={sanity}
          tagline={gbp?.name}
          headline={map?.header?.headline}
          description={map?.header?._rawDescription}
        />
        <div className="h-96">
          <iframe
            src={gbp?.gbpEmbed}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          />
        </div>
      </Container>
    </Section>
  );
};

export { MapFull };
